import { ReactNode } from "react";
import { formatAmount } from "./utils";

interface Props {
  items: any[];
  title?: string;
  className?: string;
  extra?: ReactNode;
}
const SponsorResult = ({ items, title, className, extra }: Props) => {
  const amountResult = (
    <div
      className={`takaful--sponsor-amount-result ${
        formatAmount(items.reduce((a, b) => b.amount + a, 0)).length >= 7 &&
        "takaful--padding-resize"
      } ${className}`}
    >
      <span className="takaful--sponsor-orphan-header-title">الإجمالي</span>
      <span
        className="takaful--sponsor-orphan-header-amount takaful-result-amount-part"
        style={{
          fontSize: `${
            formatAmount(items.reduce((a, b) => b.amount + a, 0)).length >= 7
              ? 1
              : 1.2
          }rem`,
        }}
      >
        {formatAmount(items.reduce((a, b) => b.amount + a, 0))}
      </span>
      <span className="takaful--sponsor-orphan-header-title icon-saudi_riyal"></span>
    </div>
  );
  return (
    <div
      className={`takaful--sponsor-result-container ${
        title !== "" ? "takaful--with-title" : "takaful--without-title"
      }`}
    >
      <span className="takaful--service-section-title">
        {`${title ?? "تفريج كربة"}`}
      </span>
      {extra ? (
        <div className="takaful--sponsor-result-extra">
          {extra}
          {amountResult}
        </div>
      ) : (
        amountResult
      )}
    </div>
  );
};

export default SponsorResult;
